import React from "react"
import { container, card } from "./card.module.css"

export const Card = ( { title, children } ) => {
  return (
    <div className={ container }>
      {title && <h1>{ title }:</h1> }
      <div className={ card }>{ children }</div>
    </div>
  )
}

export default Card
